export default __webpack_public_path__ + "c6bf7840961228faf8d911bd1d768400.png";